import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect } from 'react';
import useSWR from 'swr';
import { OutpostAttempt } from '../../../../../../../typings/outpost';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import { capitalizeFirstLetter } from '../../../../utils';
import Badge from '../../../common/base/Badge';
import Button from '../../../common/base/Button';
import Loading from '../../../common/base/Loading';
import Tabs from '../../../common/base/Tabs';
import Text from '../../../common/base/Text';
import { Div } from '../../../common/helpers/StyledUtils';
import useLocalStorage from '../../../hooks/useLocalStorage';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { StyledViewNavHeader, StyledViewNavSecondary, StyledViewSidebar, StyledViewSidebarActions, StyledViewSidebarFooter, StyledViewSidebarNav, StyledViewSidebarScrollableSection, ViewSidebarTitle } from '../../../layouts/ViewLayout';
import { OutpostDataCollapsibleSection } from '../Event/OutpostDataSection';
import { OutpostMetadataCollapsibleSection } from '../Event/OutpostMetadataSection';
import AttemptDetails from '../Attempts/AttemptDetails';
import { OUTPOST_ATTEMPT_INCLUDES } from '../Attempts/utils';
const OperatorEventAttemptSidebar: React.FC<{
  attempt_id: string;
  list_attempt?: OutpostAttempt;
  onClose: () => void;
  onPrev?: () => void;
  onNext?: () => void;
  onRetryAttempt?: (attempt: OutpostAttempt) => void;
  retrying_attempt_id?: string;
}> = t0 => {
  const $ = _c(67);
  const {
    attempt_id,
    list_attempt,
    onClose,
    onPrev,
    onNext,
    onRetryAttempt,
    retrying_attempt_id
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const [active_tab, setActiveTab] = useLocalStorage("prefs:outpost:operator-event-attempt:active-tab", "details");
  let t1;
  if ($[0] !== attempt_id) {
    t1 = APIMethodKeys.outpost.operatorEvents.attempts.get(attempt_id, {
      include: OUTPOST_ATTEMPT_INCLUDES
    });
    $[0] = attempt_id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== HookdeckAPI.outpost.operatorEvents.attempts || $[3] !== attempt_id) {
    t2 = () => HookdeckAPI.outpost.operatorEvents.attempts.get(attempt_id, {
      include: OUTPOST_ATTEMPT_INCLUDES
    });
    $[2] = HookdeckAPI.outpost.operatorEvents.attempts;
    $[3] = attempt_id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: fetched_attempt
  } = useSWR(t1, t2);
  const attempt = fetched_attempt || list_attempt;
  let t3;
  let t4;
  if ($[5] !== onClose || $[6] !== onNext || $[7] !== onPrev) {
    t3 = () => {
      const handle_keydown = event => {
        if (event.key === "ArrowUp" && onPrev) {
          event.preventDefault();
          onPrev();
        } else {
          if (event.key === "ArrowDown" && onNext) {
            event.preventDefault();
            onNext();
          } else {
            if (event.key === "Escape") {
              event.preventDefault();
              onClose();
            }
          }
        }
      };
      window.addEventListener("keydown", handle_keydown);
      return () => {
        window.removeEventListener("keydown", handle_keydown);
      };
    };
    t4 = [onPrev, onNext, onClose];
    $[5] = onClose;
    $[6] = onNext;
    $[7] = onPrev;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      align: "center",
      gap: 2
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== attempt_id) {
    t6 = <ViewSidebarTitle title={attempt_id} />;
    $[11] = attempt_id;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== attempt) {
    t7 = attempt && <Badge subtle={true} success={attempt.status === "success"} danger={attempt.status === "failed"}>{capitalizeFirstLetter(attempt.status)}</Badge>;
    $[13] = attempt;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <Div flex={t5}>{t6}{t7}</Div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== attempt || $[19] !== onRetryAttempt || $[20] !== retrying_attempt_id) {
    t9 = attempt && onRetryAttempt && <Button.Permission role="member" ghost={true} icon={retrying_attempt_id === attempt.id ? "loading" : "retry"} disabled={retrying_attempt_id === attempt.id} onClick={() => onRetryAttempt(attempt)} />;
    $[18] = attempt;
    $[19] = onRetryAttempt;
    $[20] = retrying_attempt_id;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== onClose) {
    t10 = <Button ghost={true} icon="close" onClick={onClose} />;
    $[22] = onClose;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t9) {
    t11 = <StyledViewSidebarActions>{t9}{t10}</StyledViewSidebarActions>;
    $[24] = t10;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t8) {
    t12 = <StyledViewNavHeader>{t8}{t11}</StyledViewNavHeader>;
    $[27] = t11;
    $[28] = t8;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  const nav_header = t12;
  if (!attempt) {
    let t13;
    if ($[30] !== nav_header) {
      t13 = <StyledViewSidebarNav>{nav_header}</StyledViewSidebarNav>;
      $[30] = nav_header;
      $[31] = t13;
    } else {
      t13 = $[31];
    }
    let t14;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <Div flex={{
        grow: true,
        align: "center",
        justify: "center"
      }}><Loading /></Div>;
      $[32] = t14;
    } else {
      t14 = $[32];
    }
    let t15;
    if ($[33] !== t13) {
      t15 = <StyledViewSidebar>{t13}{t14}</StyledViewSidebar>;
      $[33] = t13;
      $[34] = t15;
    } else {
      t15 = $[34];
    }
    return t15;
  }
  let t13;
  if ($[35] !== attempt.event) {
    t13 = attempt.event?.metadata ? Object.fromEntries(Object.entries(attempt.event.metadata).map(_temp)) : {};
    $[35] = attempt.event;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  const metadata_as_strings = t13;
  let t14;
  if ($[37] !== setActiveTab) {
    t14 = tab => setActiveTab(tab);
    $[37] = setActiveTab;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = [{
      key: "request",
      label: "Request"
    }, {
      key: "response",
      label: "Response"
    }, {
      key: "details",
      label: "Details"
    }];
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== active_tab || $[41] !== t14) {
    t16 = <StyledViewNavSecondary><Tabs active_tab={active_tab} border={false} onTabSelected={t14} tabs={t15} /></StyledViewNavSecondary>;
    $[40] = active_tab;
    $[41] = t14;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== nav_header || $[44] !== t16) {
    t17 = <StyledViewSidebarNav>{nav_header}{t16}</StyledViewSidebarNav>;
    $[43] = nav_header;
    $[44] = t16;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== active_tab || $[47] !== attempt) {
    t18 = active_tab === "details" && <Div p={{
      x: 6,
      b: 8
    }}><AttemptDetails attempt={attempt} embedded={true} context="operator-events" /></Div>;
    $[46] = active_tab;
    $[47] = attempt;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  let t19;
  if ($[49] !== active_tab || $[50] !== attempt.event || $[51] !== metadata_as_strings) {
    t19 = active_tab === "request" && <Div>{Object.keys(metadata_as_strings).length > 0 && <OutpostMetadataCollapsibleSection metadata={metadata_as_strings} embedded={true} context_menu={true} context_menu_config={{
        table_column_prefix: "metadata"
      }} />}{attempt.event?.data ? <OutpostDataCollapsibleSection data={attempt.event.data} embedded={true} context_menu={true} context_menu_config={{
        table_column_prefix: "data"
      }} /> : <Div p={{
        x: 6,
        y: 4
      }}><Text muted={true}>No event data available for this attempt.</Text></Div>}</Div>;
    $[49] = active_tab;
    $[50] = attempt.event;
    $[51] = metadata_as_strings;
    $[52] = t19;
  } else {
    t19 = $[52];
  }
  let t20;
  if ($[53] !== active_tab || $[54] !== attempt.response_data) {
    t20 = active_tab === "response" && <Div>{attempt.response_data ? <OutpostDataCollapsibleSection data={attempt.response_data} embedded={true} collapsible={false} /> : <Div p={{
        x: 6,
        y: 4
      }}><Text muted={true}>No response data available for this attempt.</Text></Div>}</Div>;
    $[53] = active_tab;
    $[54] = attempt.response_data;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  let t21;
  if ($[56] !== t18 || $[57] !== t19 || $[58] !== t20) {
    t21 = <StyledViewSidebarScrollableSection>{t18}{t19}{t20}</StyledViewSidebarScrollableSection>;
    $[56] = t18;
    $[57] = t19;
    $[58] = t20;
    $[59] = t21;
  } else {
    t21 = $[59];
  }
  let t22;
  if ($[60] !== onNext || $[61] !== onPrev) {
    t22 = (onPrev || onNext) && <StyledViewSidebarFooter><Div w={100} flex={{
        align: "center",
        gap: 2,
        justify: "flex-end"
      }}><Button outline={true} icon="chevron_up" onClick={onPrev} /><Button outline={true} icon="chevron_down" onClick={onNext} /></Div></StyledViewSidebarFooter>;
    $[60] = onNext;
    $[61] = onPrev;
    $[62] = t22;
  } else {
    t22 = $[62];
  }
  let t23;
  if ($[63] !== t17 || $[64] !== t21 || $[65] !== t22) {
    t23 = <StyledViewSidebar>{t17}{t21}{t22}</StyledViewSidebar>;
    $[63] = t17;
    $[64] = t21;
    $[65] = t22;
    $[66] = t23;
  } else {
    t23 = $[66];
  }
  return t23;
};
export default OperatorEventAttemptSidebar;
function _temp(t0) {
  const [key, value] = t0;
  return [key, typeof value === "object" ? JSON.stringify(value) : String(value ?? "")];
}